<template>
  <footer class="text-footer">
    <label class="container">
      <div v-html="$t('terms')" @click.prevent="handleTermsCondition"></div>
      <input type="checkbox" v-model="checked" />
      <span class="checkmark"></span>
    </label>
    <button :class="($store.state.netOnOff && checked && !inSufficient) ? '' : 'desable'" @click="CallInitiate">
      {{$t('Findfriends')}}
    </button>
  </footer>
</template>
<script>
import Vue from "vue";
import VueCookie from "vue-cookie";

Vue.use(VueCookie);
export default {
  name: "CallHistoryFooter",
  props:{
    inSufficient: Boolean
  },
  methods: {
    CallInitiate() {
      this.$cookie.set('DisconnectingStatus', 'false')
      this.$socket.emit("initiate_dost_call", {
        x_auth_id: this.$cookie.get("X-Auth-Id")
      });
      //  this.$socket.emit("user_permission_for_making_user_call", {
      //   x_auth_id: this.$cookie.get("X-Auth-Id")
      // });
      this.$router.replace("/calling-screen?callSearch=true");
    },
    handleTermsCondition() {
      this.$emit("handleTermsCondition");
    }
  },
  watch: {
    checked: function(val) {
      val
        ? VueCookie.set("termsCondition", "true")
        : VueCookie.set("termsCondition", "false");
    }
  },
  data() {
    return {
      checked: VueCookie.get("termsCondition") === "true" ? true : false
    };
  }
};
</script>
